/** Durations, limits and TTLs. ARCHITECTURE.md §7 is the source; change both together. */
export const AUTH = {
  challengeTtlMinutes: 10,
  codeAttempts: 5,
  codeLength: 6,
  requestsPerEmailPerHour: 5,
  requestsPerIpPerHour: 20,
  staffSessionHours: 12,
  patientSessionHours: 24,
  /** Any session with no request for this long is signed out; the client also signs out on its own clock. */
  idleMinutes: 15,
  accountInvitationDays: 7,
  sessionCookie: 'concord_session',
} as const;

/** Phase 1 defaults. Stored in platform_settings; these seed it (CFG-06 edits them in P5). */
export const PLATFORM_DEFAULTS = {
  invitationExpiryHours: 24,
  invitationExpiringNoticeHours: 4,
  joinWindowMinutes: 15,
  maxProposedTimes: 30,
  availabilityHorizonDays: 14,
  consultationMinutes: 30,
  uploadMaxBytes: 50 * 1024 * 1024,
  uploadAcceptedTypes: ['application/pdf', 'image/jpeg', 'image/png'],
  reminderHoursBefore: [24, 1],
  outOfPlanPolicy: 'warn',
} as const;

export const CASE_REFERENCE_PREFIX = 'CX-';
